import { createFileRoute } from '@tanstack/react-router'
import { OverviewPage } from '@/features/employee-portal/pages/OverviewPage'

export const Route = createFileRoute('/employee/')({
  component: OverviewPage,
})
